import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-bem-vindo',
  templateUrl: './bem-vindo.page.html',
  styleUrls: ['./bem-vindo.page.scss'],
})
export class BemVindoPage implements OnInit {

    authState: boolean = true;
    idAtual: any; // id do usuario atualmente logado
    itemId: any; //id o item a ser exibido
    ePropietario: boolean = false;
    eAdministrador: boolean = false;
    eAdm: boolean = false;

    mostraBt = false

    constructor(
        public navCtrl: NavController,
    ) { }

    ngOnInit() {
      this.navCtrl.navigateRoot('/home');
        //pega os dados do usu�rio atualmente logado e define o idAtual - esses dados vem do sistema de autentica��o do firebase e n�o do banco de dados.
       
    //-------------------------------------------------------------
  }

}
